import React from "react";
import "./DynamicLinks.scss";

export default class DynamicLinks extends React.Component<{}, {
  dynamicLinks: {
    id: number;
    path: string;
    redirect: string;
    actiu: boolean;
  }[];
  afegeix: {
    path: string;
    redireccio: string;
    actiu: boolean;
  } | null;
}> {
  constructor(props: any) {
    super(props);
    this.state = {
      dynamicLinks: [],
      afegeix: null
    };
  }

  componentDidMount() {
    fetch('https://api.castellersdemollet.cat/dynamicLinks')
      .then(response => response.json())
      .then(data => {
        this.setState({ dynamicLinks: data });
      })
      .catch(error => {
        throw new Error(`Error fetching dynamic links: ${error}`);
      });
  }

  postDynamicLink() {
    if (!this.state.afegeix) return;
    fetch('https://api.castellersdemollet.cat/dynamicLinks', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        path: this.state.afegeix.path,
        redirect: this.state.afegeix.redireccio,
        actiu: Boolean(this.state.afegeix.actiu ?? true),
      })
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ dynamicLinks: [...this.state.dynamicLinks, data.new], afegeix: null });
      })
      .catch(error => {
        throw new Error(`Error posting dynamic link: ${error}`);
      });
  }

  updateDynamicLink(id: number, actiu: boolean) {
    if (id === undefined || id === null) return;
    fetch(`https://api.castellersdemollet.cat/dynamicLinks?id=${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        path: this.state.dynamicLinks.find(link => link.id === id)?.path,
        redirect: this.state.dynamicLinks.find(link => link.id === id)?.redirect,
        actiu: Number(actiu)
      })
    })
      .then(response => response.json())
      .then(data => {
        this.setState({
          dynamicLinks: this.state.dynamicLinks.map(link =>
            link.id === id ? { ...link, actiu } : link
          )
        });
      })
      .catch(error => {
        throw new Error(`Error updating dynamic link: ${error}`);
      });
  }

  deleteDynamicLink(id: number) {
    fetch(`https://api.castellersdemollet.cat/dynamicLinks?id=${id}`, {
      method: 'DELETE'
    })
      .then(response => response.json())
      .then(data => {
        this.setState({ dynamicLinks: this.state.dynamicLinks.filter(link => link.id !== id) });
      })
      .catch(error => {
        throw new Error(`Error deleting dynamic link: ${error}`);
      });
  }

  testText(text: string, regex: RegExp): boolean {
    if (text === null || text === undefined) return true;
    return regex.test(text) || text.length === 0;
  }

  render(): React.ReactNode {
    return (
      <>
        <div className="dynamicLinks">
          <h1>Dynamic Links</h1>
          <table>
            <thead>
              <tr>
                <th>Enllaç</th>
                <th>Redirecció</th>
                <th>Accions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <code className="enllaç">
                    <input
                      type="text"
                      placeholder="exemple"
                      className={this.testText(this.state.afegeix?.path, /^[a-zA-Z0-9]+$/) ? 'valid' : 'invalid'}
                      onInput={
                        (e) => {
                          const input = e.target as HTMLInputElement;
                          this.setState({
                            afegeix: {
                              ...this.state.afegeix,
                              path: input.value
                            }
                          });
                        }
                      } />
                  </code>
                </td>
                <td>
                  <code className="redireccio">
                    <input
                      type="text"
                      placeholder="/exemple o https://exemple.cat"
                      className={this.testText(this.state.afegeix?.redireccio, /^(\/[a-zA-Z0-9?=]+|https?:\/\/[^\s]+)/) ? 'valid' : 'invalid'}
                      onInput={
                        (e) => {
                          const input = e.target as HTMLInputElement;
                          this.setState({
                            afegeix: {
                              ...this.state.afegeix,
                              redireccio: input.value
                            }
                          });
                        }
                      } />
                  </code>
                </td>
                <td>
                  <div className="accions">
                    <button className={Boolean(this.state.afegeix?.actiu ?? true) ? "success" : "warning"} onClick={() => {
                      this.setState({
                        afegeix: {
                          ...this.state.afegeix,
                          actiu: !Boolean(this.state.afegeix?.actiu ?? true)
                        }
                      });
                    }}>
                      {
                        Boolean(this.state.afegeix?.actiu ?? true) ? (
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                            <circle cx="18" cy="5" r="3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="6" cy="19" r="3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 5H8.5C6.567 5 5 6.567 5 8.5C5 10.433 6.567 12 8.5 12H15.5C17.433 12 19 13.567 19 15.5C19 17.433 17.433 19 15.5 19H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        ) : (
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                            <path d="M15 2L21 8M21 2L15 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <circle cx="6" cy="19" r="3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 5H8.5C6.567 5 5 6.567 5 8.5C5 10.433 6.567 12 8.5 12H15.5C17.433 12 19 13.567 19 15.5C19 17.433 17.433 19 15.5 19H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        )
                      }
                    </button>
                    <button className="success" onClick={
                      () => {
                        if (!this.state.afegeix) return;
                        this.postDynamicLink();
                      }
                    }>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                        <path d="M8 22V19C8 17.1144 8 16.1716 8.58579 15.5858C9.17157 15 10.1144 15 12 15C13.8856 15 14.8284 15 15.4142 15.5858C16 16.1716 16 17.1144 16 19V22" stroke="#000000" strokeWidth="1.5" strokeLinejoin="round"></path>
                        <path d="M10 7H14" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        <path d="M3 11.8584C3 7.28199 3 4.99376 4.38674 3.54394C4.43797 3.49038 4.49038 3.43797 4.54394 3.38674C5.99376 2 8.28199 2 12.8584 2C13.943 2 14.4655 2.00376 14.9628 2.18936C15.4417 2.3681 15.8429 2.70239 16.6452 3.37099L18.8411 5.20092C19.9027 6.08561 20.4335 6.52795 20.7168 7.13266C21 7.73737 21 8.42833 21 9.81025V13C21 16.7497 21 18.6246 20.0451 19.9389C19.7367 20.3634 19.3634 20.7367 18.9389 21.0451C17.6246 22 15.7497 22 12 22C8.25027 22 6.3754 22 5.06107 21.0451C4.6366 20.7367 4.26331 20.3634 3.95491 19.9389C3 18.6246 3 16.7497 3 13V11.8584Z" stroke="#000000" strokeWidth="1.5"></path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
              {
                this.state.dynamicLinks.map((_, i) => (
                  <tr key={i}>
                    <td>
                      <code>
                        {_.path}
                        <button className="copy" onClick={(e) => {
                          navigator.clipboard.writeText(`https://castellersdemollet.cat/l/${_.path}`);
                          (e.target as HTMLButtonElement).classList.add("copiat");
                          setTimeout(() => {
                            (e.target as HTMLButtonElement).classList.remove("copiat");
                          }, 1000);
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                            <path d="M9 15C9 12.1716 9 10.7574 9.87868 9.87868C10.7574 9 12.1716 9 15 9L16 9C18.8284 9 20.2426 9 21.1213 9.87868C22 10.7574 22 12.1716 22 15V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H15C12.1716 22 10.7574 22 9.87868 21.1213C9 20.2426 9 18.8284 9 16L9 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M16.9999 9C16.9975 6.04291 16.9528 4.51121 16.092 3.46243C15.9258 3.25989 15.7401 3.07418 15.5376 2.90796C14.4312 2 12.7875 2 9.5 2C6.21252 2 4.56878 2 3.46243 2.90796C3.25989 3.07417 3.07418 3.25989 2.90796 3.46243C2 4.56878 2 6.21252 2 9.5C2 12.7875 2 14.4312 2.90796 15.5376C3.07417 15.7401 3.25989 15.9258 3.46243 16.092C4.51121 16.9528 6.04291 16.9975 9 16.9999" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </button>
                      </code>
                    </td>
                    <td>
                      <code>
                        {_.redirect}
                        <button className="copy" onClick={(e) => {
                          navigator.clipboard.writeText(`${_.redirect.startsWith('/') ? 'https://castellersdemollet.cat' : ''}${_.redirect}`);
                          (e.target as HTMLButtonElement).classList.add("copiat");
                          setTimeout(() => {
                            (e.target as HTMLButtonElement).classList.remove("copiat");
                          }, 1000);
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                            <path d="M9 15C9 12.1716 9 10.7574 9.87868 9.87868C10.7574 9 12.1716 9 15 9L16 9C18.8284 9 20.2426 9 21.1213 9.87868C22 10.7574 22 12.1716 22 15V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H15C12.1716 22 10.7574 22 9.87868 21.1213C9 20.2426 9 18.8284 9 16L9 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M16.9999 9C16.9975 6.04291 16.9528 4.51121 16.092 3.46243C15.9258 3.25989 15.7401 3.07418 15.5376 2.90796C14.4312 2 12.7875 2 9.5 2C6.21252 2 4.56878 2 3.46243 2.90796C3.25989 3.07417 3.07418 3.25989 2.90796 3.46243C2 4.56878 2 6.21252 2 9.5C2 12.7875 2 14.4312 2.90796 15.5376C3.07417 15.7401 3.25989 15.9258 3.46243 16.092C4.51121 16.9528 6.04291 16.9975 9 16.9999" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </button>
                      </code>
                    </td>
                    <td>
                      <div className="accions">
                        <button className="primary" onClick={(e) => {
                          const path = document.querySelector(`.dynamicLinks tbody tr:nth-child(${i + 2}) td:nth-child(1) code`) as HTMLInputElement;
                          const redirect = document.querySelector(`.dynamicLinks tbody tr:nth-child(${i + 2}) td:nth-child(2) code`) as HTMLInputElement;
                          console.log(path, redirect);
                          if (path && redirect) {
                            path.contentEditable = `${!path.isContentEditable}`;
                            redirect.contentEditable = `${!redirect.isContentEditable}`;
                            path.focus({

                            });
                          }
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 10.067 10.067 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12Z" stroke="#000000" strokeWidth="1.5" />
                            <path d="M20.7906 9.15201C21.5969 10.5418 22 11.2366 22 12C22 12.7634 21.5969 13.4582 20.7906 14.848L18.8669 18.1638C18.0638 19.548 17.6623 20.2402 17.0019 20.6201C16.3416 21 15.5402 21 13.9373 21L10.0627 21C8.45982 21 7.6584 21 6.99807 20.6201C6.33774 20.2402 5.93619 19.548 5.13311 18.1638L3.20942 14.848C2.40314 13.4582 2 12.7634 2 12C2 11.2366 2.40314 10.5418 3.20942 9.152L5.13311 5.83621C5.93619 4.45196 6.33774 3.75984 6.99807 3.37992C7.6584 3 8.45982 3 10.0627 3L13.9373 3C15.5402 3 16.3416 3 17.0019 3.37992C17.6623 3.75984 18.0638 4.45197 18.8669 5.83622L20.7906 9.15201Z" stroke="#000000" strokeWidth="1.5" />
                          </svg>
                        </button>
                        <button className={`actiu ${Boolean(_.actiu) ? "success" : "warning"}`} disabled={true} onClick={
                          () => {
                            this.updateDynamicLink(_.id, !Boolean(_.actiu));
                          }
                        }>
                          {
                            Boolean(_.actiu) ? (
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                                <circle cx="18" cy="5" r="3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <circle cx="6" cy="19" r="3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 5H8.5C6.567 5 5 6.567 5 8.5C5 10.433 6.567 12 8.5 12H15.5C17.433 12 19 13.567 19 15.5C19 17.433 17.433 19 15.5 19H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            ) : (
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                                <path d="M15 2L21 8M21 2L15 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <circle cx="6" cy="19" r="3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M12 5H8.5C6.567 5 5 6.567 5 8.5C5 10.433 6.567 12 8.5 12H15.5C17.433 12 19 13.567 19 15.5C19 17.433 17.433 19 15.5 19H12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                            )
                          }
                        </button>
                        <button className="danger" onClick={
                          () => {
                            this.deleteDynamicLink(_.id);
                          }
                        } disabled={_.id === undefined}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" />
                            <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" />
                            <path d="M9.5 16.5L9.5 10.5" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" />
                            <path d="M14.5 16.5L14.5 10.5" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" />
                          </svg>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </>
    );
  }
}